import React from 'react'
import { Button, Spinner } from 'reactstrap'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { ArrowCircleDown, ShoppingCart } from 'phosphor-react'
import Cookies from 'universal-cookie'
import api from '../../api/api'
import { processError } from '../../lib/lib'

const cookies = new Cookies()

class BuyButton extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            addToCartAction: false,
        }
        this.addToCart = this.addToCart.bind(this)
    }

    async catalogAddToStudy(catalogId) {
        const token = cookies.get('accessToken')
        const { history } = this.props
        api.catalogAddToStudy({ token, catalogId })
            .then(() => {
                history.push('/study')
                this.setState({ addToCartAction: false })
            })
            .catch((e) => processError(e, history))
    }

    async catalogGetBuyUrlAndBuy(catalogId) {
        const token = cookies.get('accessToken')
        const { history, lang } = this.props
        api.catalogGetBuyUrl({ token, catalogId, lang })
            .then(({ url }) => {
                window.open(url, "_blank")
                this.setState({ addToCartAction: false })
            })
            .catch((e) => processError(e, history))
    }

    addToCart(event) {
        event.preventDefault()
        const { history, item } = this.props
        this.setState({ addToCartAction: true })
        // const accessExired = item.type === 3 && item.accessExpired
        if (item.alreadyHas &&
            // !accessExired
            item.type !== 3
        ) {
            history.push(`/study`)
            return
        }
        if (!item.newPrice) {
            this.catalogAddToStudy(item.id)
            return
        }
        if (item.buyUrl) {
            this.catalogGetBuyUrlAndBuy(item.id)
            return
        }
        const classSelector = `.${this.props.className.split(' ').join('.')}`
        const button = event.target.closest(classSelector)
        if (button.classList.contains('active')) {
            history.push('/cart')
        } else {
            this.activateBtn(button)
            const items = cookies.get('order') || []
            items.push({
                userId: cookies.get('userId'),
                itemId: item.id,
            })
            cookies.set('order', items, { path: '/' })
            this.setState({ addToCartAction: false })
        }
    }

    render() {
        const { t, className, item } = this.props
        // const accessExired = item.type === 3 && item.accessExpired
        const disabled = (item.ableToSale || this.state.addToCartAction) && item.access ? false : true
        return (
            <Button
                className={className}
                onClick={(e) => item.access && this.addToCart(e)}
                disabled={disabled}
            >
                {
                    this.state.addToCartAction && item.access ?
                        <Spinner size="sm" />
                        :
                        <div className="news-btn-content">
                            <ArrowCircleDown className="circle-down-icon" size={20} color={'#ffffff'} />
                            <ShoppingCart className="shopping-cart-icon d-none" size={20} color={'#ffffff'} />
                            <span className="news-btn-desc sm-font-size" color={'#ffffff'}>
                                {
                                    item.alreadyHas === true &&
                                    // !accessExired
                                    item.type !== 3 ?
                                        t('catalog-continue-study') :
                                        item.ableToSale ?
                                            item.newPrice ?
                                                item.buyUrl ?
                                                    t('catalog-buy') :
                                                    t('catalog-purchase-program') :
                                                t('catalog-add-to-study')
                                            : t('catalog-on-sale-soon')
                                }
                            </span>
                        </div>
                }
            </Button>
        )
    }
}

BuyButton.propTypes = {
    t: PropTypes.func,
    className: PropTypes.string,
    item: PropTypes.object,
    history: PropTypes.object,
    lang: PropTypes.string,
}

export default withTranslation()(BuyButton)



// WEBPACK FOOTER //
// ./src/components/UI/BuyButton.jsx